module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scrollableArea"
  }, [(!_vm.$route.meta.reschedule) ? _c('navigator', {
    attrs: {
      "product": _vm.reservation.product
    }
  }) : _vm._e(), _vm._v(" "), _c('filters', {
    attrs: {
      "availableResources": _vm.availableResources,
      "availableDurations": _vm.availableDurations,
      "filters": _vm.filters
    },
    on: {
      "filterChanged": _vm.filterChanged
    }
  }), _vm._v(" "), (_vm.events.length > 0) ? _c('div', {
    staticClass: "container-fluid scrollThis"
  }, _vm._l((_vm.eventsGroupedByDay), function(dayGroup) {
    return _c('single-day', {
      key: dayGroup.date,
      attrs: {
        "product": _vm.getReservationSelectedProduct,
        "group": dayGroup,
        "reservationDetails": _vm.userBookingInfo
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.loadingEvents) ? _c('div', {
    staticClass: "dark fs-larger font-weight-600 text-center mt-4"
  }, [_c('loader')], 1) : _vm._e(), _vm._v(" "), (!_vm.loadingEvents && _vm.filteredEvents.length == 0) ? _c('div', {
    staticClass: "dark fs-large text-center font-weight-600 mt-4"
  }, [_vm._v("\n        No events found\n    ")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2451a2ac"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/NewReservation/Availability.vue
// module id = 2454
// module chunks = 0